import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/layouts/default.vue").then(m => m.default || m)),
  mobile: defineAsyncComponent(() => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/layouts/mobile.vue").then(m => m.default || m)),
  nude: defineAsyncComponent(() => import("/workspace/source/hcon-app-stg-hcon-fo-ui/src/layouts/nude.vue").then(m => m.default || m))
}